import { render } from "./EditGroup.vue?vue&type=template&id=aad031fa&scoped=true"
import script from "./EditGroup.vue?vue&type=script&lang=js"
export * from "./EditGroup.vue?vue&type=script&lang=js"

import "./EditGroup.vue?vue&type=style&index=0&id=aad031fa&lang=scss&scoped=true"
import "./EditGroup.vue?vue&type=style&index=1&id=aad031fa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad031fa"]])

export default __exports__